import React, { FC } from 'react'
import styles from './Loading.module.scss'
import { Spinner } from 'components/Spinner'

export const Loading: FC = () => (
  <div className={styles.loading}>
    <Spinner />
  </div>
)

Loading.displayName = 'Loading'
